var styles = {"root":"hero-box-block--root","heading":"hero-box-block--heading","topLeft":"hero-box-block--top-left","topRight":"hero-box-block--top-right","bottomLeft":"hero-box-block--bottom-left","bottomRight":"hero-box-block--bottom-right","text":"hero-box-block--text","linkOverlay":"hero-box-block--link-overlay"};

export { styles as default };
//# sourceMappingURL=HeroBoxBlock.module.esm.js.map
